import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { RoleLiteDto } from '../../api/role/models/RoleDto'
import Card from '../common/cards/Card'
import { Pages } from '../../Pages'
import ContractTypeBadge from './ContractTypeBadge'
import { Link } from 'react-router-dom'
import ExpandableText from '../common/expandable/ExpandableText'

type Props = {
    role: RoleLiteDto
    showJobDescription?: boolean
    clickable?: boolean
}

export default function RoleCard({
    role,
    showJobDescription = false,
    clickable = true,
}: Props): React.JSX.Element {
    const cardContent = (
        <Card
            className={`${
                clickable ? 'cursor-pointer hover:bg-gray-50' : ''
            } flex items-center`}
        >
            <div className="flex justify-between w-full">
                <div className="w-full flex flex-col text-sm text-gray-600">
                    <div className="flex justify-between items-baseline">
                        <div className="font-semibold text-gray-900 text-lg leading-tight mr-2">
                            {role.jobTitle}
                        </div>
                        {role.contractType !== undefined ? (
                            <ContractTypeBadge
                                contractType={role.contractType}
                            />
                        ) : null}
                    </div>

                    <div className="flex items-center mt-1 text-sm text-gray-700">
                        <span className="line-clamp-1 italic">
                            {role.location || null}
                        </span>
                    </div>

                    {showJobDescription && (
                        <>
                            <hr className="my-2 w-2/3 mx-auto"></hr>
                            <div className="flex items-center mt-1 text-sm text-gray-700">
                                <ExpandableText maxLines={4}>
                                    <div className="whitespace-pre-line">
                                        {role.jobDescription || null}
                                    </div>
                                </ExpandableText>
                            </div>
                        </>
                    )}
                </div>

                {clickable && (
                    <div className="flex items-center pl-4">
                        <FontAwesomeIcon
                            icon={faChevronRight}
                            className="text-gray-400"
                        />
                    </div>
                )}
            </div>
        </Card>
    )

    if (clickable) {
        return (
            <Link to={`${Pages.ViewRole}?id=${role.id}`} className="block">
                {cardContent}
            </Link>
        )
    }

    return cardContent
}
